export const pubDate = (published) => {
  if (!published) return null;
  const iso = published.length <= 10 ? `${published}T00:00:00Z` : `${published.replace(/(Z|[+-]\d\d:\d\d)$/, "")}Z`;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const articleState = (a) => {
  if (a?.status === "draft") return "draft";
  const d = pubDate(a?.published);
  return d && d > new Date() ? "scheduled" : "live";
};

export const toLocalInput = (date) => {
  if (!date) return "";
  const off = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - off).toISOString().slice(0, 16);
};

export const fmtDateTime = (date) =>
  date ? date.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

const STYLES = {
  live: "bg-ink text-cream",
  scheduled: "bg-hot text-ink border border-ink/30",
  draft: "bg-blush text-ink border border-ink/30",
};

export const StatusBadge = ({ a, testId }) => {
  const s = articleState(a);
  const label = s === "scheduled" ? `Scheduled · ${fmtDateTime(pubDate(a.published))}` : s;
  return <span className={`kicker px-2 py-1 inline-block ${STYLES[s]}`} data-testid={testId}>{label}</span>;
};
